import { isEmpty } from 'lodash';
import {
    borderCurve,
    BoxesIcon,
    type ColorTokenKey,
    Icon,
    type IconType,
    ReceiptTextIcon,
    Shadows,
    tokens,
    View,
    type ViewProps,
} from 'smoothie';

export enum BillIconSize {
    XS = 40,
    SMALL = 50,
    MEDIUM = 62,
    LARGE = 70,
    XL = 100,
}

interface IconProps extends ViewProps {
    icon?: IconType | null;
    color?: string | null;
    iconColor?: string | null;
    size: BillIconSize;
    hasShadow?: boolean;
}

const providedOrDefaultIcon = (icon?: IconType | null) => {
    return icon ?? ReceiptTextIcon;
};

const providedOrDefaultColor = (color?: string | null) => {
    return color == null || isEmpty(color)
        ? (color = tokens.color.light.peach.peach300)
        : color;
};

export const BillIcon = ({
    icon,
    color,
    iconColor,
    size,
    hasShadow = false,
    ...props
}: IconProps) => {
    return (
        <View
            backgroundColor={providedOrDefaultColor(color)}
            height={size}
            maxHeight={size}
            width={size}
            maxWidth={size}
            flex={1}
            alignItems="center"
            justifyContent="center"
            borderRadius={12}
            style={hasShadow ? { ...Shadows.SMALL } : undefined}
            {...borderCurve('continuous')}
            {...props}
        >
            <Icon
                icon={providedOrDefaultIcon(icon)}
                color={
                    (iconColor !== null
                        ? iconColor
                        : 'rgba(0,0,0,.7)') as ColorTokenKey
                }
                size={size * 0.4}
            />
        </View>
    );
};

export const BillDetailIcon = ({ icon, color, size }: IconProps) => {
    return (
        <View
            backgroundColor={providedOrDefaultColor(color)}
            height={size}
            maxHeight={size}
            width={size}
            maxWidth={size}
            alignItems="center"
            justifyContent="center"
            borderColor="$white"
            borderWidth={1}
            borderRadius={16}
        >
            <Icon
                icon={providedOrDefaultIcon(icon)}
                size={20}
                color="$gray1100"
            />
        </View>
    );
};

export const CubesIcon = () => {
    return (
        <View
            borderRadius={9999}
            padding={16}
            gap={10}
            backgroundColor="$black"
            width={72}
            height={72}
            alignItems="center"
            justifyContent="center"
        >
            <Icon icon={BoxesIcon} size={32} color="$white" />
        </View>
    );
};
